<template>
    <v-flex xs12 lg12>
        <v-card flat>
            <v-card-text>

                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>

                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>

                <v-flex xl12>
                    <v-layout wrap>
                        <v-spacer></v-spacer>
                        <v-text-field @input="getDataFromApi" append-icon="search" label="Procurar" single-line
                                      hide-details
                                      v-model="search"></v-text-field>
                    </v-layout>
                </v-flex>

                <v-data-table flat
                              :headers="headers"
                              :items="registries"
                              :rows-per-page-text="'Registros por página '"
                              :no-data-text="'Sem registros'"
                              :pagination.sync="pagination"
                              :total-items="totalRegistries"
                              :loading="loading"
                              class="elevation-0"
                >
                    <template v-slot:items="props">
                        <td class="text-xs-center">
                            <v-img width="110" style="padding: 2px;margin: 4px;"
                                   :src="props.item.image"
                                    :lazy-src="props.item.image"
                                    aspect-ratio="1.0005"
                                    class="grey lighten-2 elevation-2"

                            >
                                <template v-slot:placeholder>
                                    <v-layout
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-2
                                    >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-layout>
                                </template>
                            </v-img>
                        </td>
                        <td width="10" class="text-xs-center">{{ props.item.code }}</td>
                        <td class="text-xs-left">{{ props.item.address_type }} {{ props.item.address }}, {{ props.item.number }} {{ props.item.city }} - {{ props.item.state }} </td>
                        <td width="10" class="text-xs-left">{{ props.item.bedrooms }}</td>
                        <td width="10" class="text-xs-left">{{ props.item.suites }}</td>
                        <td width="10" class="text-xs-center">{{ props.item.bathrooms }}</td>
                        <td width="10" class="text-xs-center">{{ props.item.parking_spaces }}</td>
                        <td class="text-xs-center">{{ props.item.modified }}</td>
                        <td class="text-xs-center">{{ props.item.created }}</td>
                    </template>
                </v-data-table>

                <v-dialog v-model="dialog" persistent max-width="50%">
                    <v-card dark>
                        <v-card-title class="headline">
                            <span style="font-size: 14px;">Tem certeza que deseja {{action.action_name}} este registro?</span>
                        </v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark color="red darken-1" flat @click.native="dialog = false">NÃO</v-btn>
                            <v-btn dark color="green darken-1" flat @click.native="change">SIM</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    export default {
        name: 'properties-list',
        data() {
            return {
                success: false,
                error: false,
                dialog: false,
                messages: '',
                search: '',
                action: {
                    action_name: '',
                    id: 0,
                    status: ''
                },
                totalRegistries: 0,
                registries: [],
                loading: true,
                pagination: {rowsPerPage: 20, search: ''},
                headers: [
                    {text: 'Foto', value: 'image', align: 'left'},
                    {text: 'Código', value: 'code', align: 'center'},
                    {text: 'Local', value: 'id', align: 'left'},
                    {text: 'Quartos', value: 'bedrooms', align: 'center'},
                    {text: 'Suites', value: 'suites', align: 'center'},
                    {text: 'Banheiros', value: 'bathrooms', align: 'center'},
                    {text: 'Garagens', value: 'parking_spaces', align: 'center'},
                    {text: 'Atualização', value: 'modified', align: 'center'},
                    {text: 'Cadastro', value: 'created', align: 'center'},
                ]
            }
        },
        watch: {
            pagination: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true
            }
        },
        mounted() {
            this.getDataFromApi()
            this.$store.commit('setLoading', true)
        },
        methods: {
            doChange(row, status) {
                if (status == 'S') {
                    this.action.action_name = 'suspender'
                } else if (status === 'A') {
                    this.action.action_name = 'ativar'
                } else if (status === 'D') {
                    this.action.action_name = 'apagar'
                }
                this.action.id = row
                this.action.status = status
                this.dialog = true
            },
            change() {
                var self = this
                self.loading = true
                self.axios.post('/update-properties.json', this.action, {
                    headers: {
                        'Authorization': this.$store.state.token
                    }
                }).then((response) => {
                    if (response.data.success === true) {
                        self.getDataFromApi()
                        self.dialog = self.loading = false
                    }
                })
            },
            doEdit(row) {
                localStorage.setItem('register', JSON.stringify(row))
                this.$router.push({name: 'properties-edit'})
            },
            getDataFromApi() {
                var self = this
                var data = this.pagination
                data.search = this.search
                data.role = this.role
                self.loading = true
                self.axios.get('/list-properties.json', {
                    params: {
                        data
                    },
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.registries = response.data.registries
                    self.totalRegistries = response.data.totalRegistries
                    self.loading = false
                })
            }
        }
    }
</script>
